import React from "react";
import { DayInterface } from "../interfacesAndTypes";
import Lecture from "./Lecture";

interface DayPropsInterface {
  day: DayInterface;
  video: { src: string; title: string };
  setVideo: (video: { src: string; title: string; topic: string }) => void;
}
export default function Day(props: DayPropsInterface) {
  const { day, video, setVideo } = props;
  return (
    <div>
      {day.lectures.map((lecture, index) => (
        <Lecture data={lecture} key={index} video={video} setVideo={setVideo} />
      ))}
    </div>
  );
}
